import { tiendasApi } from '../api'

export const reportesApiSlice = tiendasApi.injectEndpoints({
    endpoints: builder => ({
        getClientesVigentes: builder.query({
            query: ({ vendedorId }) => ({
                url: 'reportes/cantidad-vigentes',
                method: 'GET',
                params: {
                    vendedorId
                }
            })
        }),
        getClientesVencidos: builder.query({
            query: ({ vendedorId }) => ({
                url: 'reportes/cantidad-vencidos',
                method: 'GET',
                params: {
                    vendedorId
                }
            })
        }),
        getClientesVencidosDetalle: builder.query({
            query: ({ page=1, itemsPerPage=25, vendedorId }) => ({
                url: 'reportes/cantidad-vencidos/detalle',
                method: 'GET',
                params: {
                    vendedorId,
                    page,
                    itemsPerPage
                }
            })
        }),
        getVendidoPorVendedor: builder.query({
            query: ({ fechaDesde, fechaHasta, vendedorId }) => ({
                url: 'reportes/pagos-totales-por-vendedor',
                method: 'GET',
                params: {
                    fechaDesde,
                    fechaHasta,
                    vendedorId
                }
            })
        }),
        getFacturadoByProvincia: builder.query({
            query: ({ fechaDesde, fechaHasta, vendedorId }) => ({
                url: 'reportes/pagos-totales-por-provincia',
                method: 'GET',
                params: {
                    fechaDesde,
                    fechaHasta,
                    vendedorId
                }
            })
        }),
    })
})

export const {
    useGetClientesVigentesQuery,
    useGetClientesVencidosQuery,
    useGetClientesVencidosDetalleQuery,
    useGetVendidoPorVendedorQuery,
    useGetFacturadoByProvinciaQuery,
} = reportesApiSlice